import { apiAdd, apiDelete, apiGet, apiUpdate } from "../../API/Service/apiClient";


export const handleGetAddons_list = async(
  {filter,setAddons,setLoading}) => {
  setLoading(true);
  try {
    const resData = await apiGet("addons", filter);    
    setAddons(resData?.data);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleAddons_Create =
 async({setLoaderADES,addons,setAddons,values,resetForm}) => {
  setLoaderADES({create:true});
  try {    
    
    const resData = await apiAdd("addons", values);        
    if(resData?.data?.id > 0){
      setAddons([...addons, { ...values, id: resData?.data?.id }]);
      resetForm();
    }else{
      alert("Something went wrong! Please try again")
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
};

export const handleAddons_Update =
 async({setLoaderADES,item}) => {
  setLoaderADES({update:item?.id});
  try {    
    const resData = await apiUpdate("addons", item);        
    if(resData?.data?.id > 0){      
    }else{
      alert("Something went wrong! Please try again")
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
};

export const handleAddons_Delete =
 async({setLoaderADES,setAddons,id}) => {
  setLoaderADES({delete:id});
  try {    
    let data={id:id}
    const resData = await apiDelete("addons", data);    
    if(resData?.data > 0){
      setAddons(prevSizes => prevSizes.filter(row => row.id !== id));
    }else{
      alert("Something went wrong! Please try again")
    }   
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
};

export const handleInputChange = (id, field, value,setAddons) => {
    setAddons((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );  
};
